import { trustItems } from '@/mocks/siteData';

export default function TrustBar() {
  return (
    <section className="py-6 md:py-8 bg-background-50 border-y border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <span className="text-xs md:text-sm font-medium text-foreground-500 whitespace-nowrap">
            Used For:
          </span>
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className={`${item.icon} text-base text-primary-500`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-700 whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}